// 手机号验证
export function isvalidPhone(str) {
    const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
    return reg.test(str)
}

// 价格验证
export function isvalidPrice(str) {
    const reg = /^(([0-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/
    return reg.test(str)
}

// 密码验证
export function isvalidPassword(str) {
    const reg = /^[0-9|@#*$%_,.|A-Z|a-z]{6,20}$/
    return reg.test(str)
}

// 用户名验证
export function isvalidUserName(str) {
    const reg = /^[a-zA-Z]([-_a-zA-Z0-9]{3,19})+$/
    return reg.test(str)
}

// 星级输入限制1位，0-5数字
export function isvalidStar(str) {
    const reg = /^[0-5]{1}$/
    return reg.test(str)
}
// 限制3位，任意数字
export function isvalidNumber3(str) {
    const reg = /^[0-9]{1,3}$/
    return reg.test(str)
}

// 邮箱验证
export function isvalidEmail(str) {
    const reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
    return reg.test(str)
}


// 身份证验证
export function isvalidCardId(str) {
    const reg = /^[1-9][0-9]{5}(?:19|20)?[0-9]{2}(?:0[1-9]|1[012])(?:0[1-9]|[12][0-9]|3[01])[0-9]{3}[0-9Xx]?$/
    return reg.test(str)
}


// WEBPACK FOOTER //
// ./src/store/validate.js